<div *ngIf="form?.errors">
    <ul>
      <li *ngFor="let msg of getMessages()">
        {{ msg || ('SHARED.UNKNOWN_ERROR' | translate) }}
      </li>
    </ul>
  </div>
